import React, { useEffect, useState } from 'react';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import './FactSheetPage.css';

interface FAQItem {
  question: string;
  answer?: string;
  property: string;
  isOpen: boolean;
}

const FactSheetPage: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const [faqs, setFaqs] = useState<FAQItem[]>([
    {
      question: "Sem accumsan orci nam nisl tellus dictum fringilla.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Ridiculus arcu nunc amet id vel turpis condimentum.",
      property: "awasi atacama",
      isOpen: false
    },
    {
      question: "Vulputate sit ac molestie odio velit fermentum leo.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Sit volutpat pellentesque rhoncus sagittis aliquam.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Amet quisque odio ultricies adipiscing consectetur.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Nunc purus sed consectetur quis risus pellentesque.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Amet platea posuere urna nec egestas vitae egestas.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Elit dis elementum duis bibendum tellus parturient.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Velit in amet iaculis erat mauris nam pellentesque.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Duis imperdiet lacus lacinia sapien facilisis nunc.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Hendrerit mattis libero tellus tincidunt curabitur.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Nisl dolor odio felis diam non tristique tristique.",
      property: "Awasi atacama",
      isOpen: false
    },
    {
      question: "Diam mauris enim egestas et nullam eget vestibulum.",
      property: "Awasi atacama",
      isOpen: false
    },
  ]);

  const [selectedProperty, setSelectedProperty] = useState<string | null>(null);
  const [selectedType, setSelectedType] = useState<string | null>(null);

  // Initialize interactive features and clear hover state
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initializeAllFeatures();
    setHoveredDestination(null);
    return cleanup;
  }, [setHoveredDestination]);

  const toggleFAQ = (index: number) => {
    setFaqs(prevFaqs => 
      prevFaqs.map((faq, i) => ({
        ...faq,
        isOpen: i === index ? !faq.isOpen : faq.isOpen
      }))
    );
  };

  return (
    <div className="fact-sheet-page">
      <SmartNavigation forceVariant="light" />
      
      {/* Hero Section - Diptych */}
      <div className="fact-sheet-hero" data-scroll-section="hero">
        <div className="hero-text-block">
          <div className="hero-content">
            <h1>Sit in fermentum donec tincidunt. Felis sit diam varius quam consequat adipiscing.</h1>
            <p>
              Quis sagittis tincidunt tristique viverra. Blandit netus augue lacus adipiscing malesuada 
              pulvinar at leo feugiat. Eget viverra enim nunc enim vitae pellentesque viverra tortor lorem. 
              Sit phasellus quis feugiat eros sociis maecenas. Semper ante enim aenean tincidunt ultrices at. 
              Aliquam fusce eget platea faucibus in metus.
            </p>
            <a 
              href="/assets/Awasi-Atacama-Factsheet-ENG.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="fact-sheet-download-button"
            >
              VIEW FACT SHEET
            </a>
          </div>
          <img src="/assets/images/gallery-small1.png" alt="Small detail" className="hero-small-image" />
        </div>
        <div className="hero-image" style={{ backgroundImage: `url('/assets/atacama-factsheet-hero.jpg')` }}></div>
      </div>

      {/* FAQ Section */}
      <div className="fact-sheet-faq-section" data-scroll-section="faqs">
        <div className="faq-filters">
          <button 
            className={`filter-button ${selectedProperty === 'atacama' ? 'active' : ''}`}
            onClick={() => setSelectedProperty(selectedProperty === 'atacama' ? null : 'atacama')}
          >
            Awasi atacama +
          </button>
          <button 
            className={`filter-button ${selectedType ? 'active' : ''}`}
            onClick={() => setSelectedType(selectedType ? null : 'type')}
          >
            Type +
          </button>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${faq.isOpen ? 'open' : ''}`}>
              <div className="faq-header" onClick={() => toggleFAQ(index)}>
                <h3>{faq.question}</h3>
                <div className="faq-meta">
                  <span className="faq-property">{faq.property}</span>
                  <button className="faq-toggle">
                    {faq.isOpen ? (
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M3.5 8.5H13.5" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    ) : (
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M8.5 3.5V13.5M3.5 8.5H13.5" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              {faq.isOpen && faq.answer && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Full Image Section */}
      <div 
        className="fact-sheet-full-image" 
        data-scroll-section="full-image"
        style={{ backgroundImage: `url('/assets/atacama-full-factsheet.jpg')` }}
      ></div>

      {/* Instagram Section */}
      <div data-scroll-section="instagram">
        <InstagramSection 
          title="Follow us on Instagram @awasiexperience"
          posts={[
            { src: images.film13, alt: "Instagram 1" },
            { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
            { src: images.film14, alt: "Instagram 3" },
            { src: images.film15, alt: "Instagram 4" }
          ]}
        />
      </div>

      {/* Footer */}
      <Footer variant="atacama" />
    </div>
  );
};

export default FactSheetPage;